<template>
  <v-content>
    <!-- Selector -->
    <section class="mx-3">
      <v-flex xs12 style="margin-top: 80px;">
        <v-card>
          <v-card-title>
            <v-layout row wrap>
              <!-- Device -->
              <v-flex xs12 md3 :class="mobileSel">
                <v-select
                  :label="selPlayerLang()"
                  max-height="400"
                  :items="$store.getters.getDevices"
                  item-text="name"
                  item-value="item"
                  v-model="selectedPlayer"
                  @input="updateSelectedDevice()"
                  hide-details
                  class="pr-3"
                ></v-select>
              </v-flex>
              <!-- Start date -->
              <v-flex xs6 md2 offset-md1 :class="mobileSel">
                <v-menu
                  id="dateSelBar"
                  hide-details
                  lazy
                  :close-on-content-click="false"
                  v-model="startDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-bottom="30"
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :label="selDateStartLang()"
                    v-model="startDate"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="startDateTemp"
                    :locale="localeLang()"
                    first-day-of-week="1"
                    no-title
                    color="primary"
                    @input="changeStartDate()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- End date -->
              <v-flex xs6 md2 :class="mobileSel">
                <v-menu
                  id="dateSelBar"
                  hide-details
                  lazy
                  :close-on-content-click="false"
                  v-model="endDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-bottom="30"
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :label="selDateStartLang()"
                    v-model="endDate"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="endDateTemp"
                    :locale="localeLang()"
                    first-day-of-week="1"
                    no-title
                    color="primary"
                    @input="changeEndDate()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- Update Button -->
              <v-flex xs12 md4 text-xs-center text-md-right>
                <v-btn round color="success" @click="downloadStats()">
                  {{updateBtnLang()}}&nbsp;&nbsp;
                  <v-icon>refresh</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </section>
    <!-- Statistics -->
    <section class="mx-3">
      <v-layout row wrap class="mb-5 pb-3">
        <!-- Views Stats -->
        <v-flex xs12 sm8 class="pt-3">
          <v-layout row wrap>
            <!-- Graph -->
            <v-flex xs12 class="statsStyle statsBorder">
              <line-chart :chart-data="viewChart" :options="optionsLine" :height="chartHeight"></line-chart>
            </v-flex>
            <!-- Small Stats -->
            <v-layout row wrap align-center justify-center class="mt-5">
              <v-flex xs12 md3>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12>
                    <v-layout class="containerCircle">
                      <div class="outerCircle viewsCol"></div>
                      <div class="innerCircle">
                        <div class="font-number">{{totalViewsPer}}</div>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-lang.viewsPeriod class="font-subtitle-3 my-3" text-xs-center></v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md3>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12>
                    <v-layout class="containerCircle">
                      <div class="outerCircle likesCol"></div>
                      <div class="innerCircle">
                        <div class="font-number">{{totalLikesPer}}</div>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-lang.likesPeriod class="font-subtitle-3 my-3" text-xs-center></v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md3>
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12>
                    <v-layout class="containerCircle">
                      <div class="outerCircle dislikesCol"></div>
                      <div class="innerCircle">
                        <div class="font-number">{{totalDislikesPer}}</div>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-lang.dislikesPeriod class="font-subtitle-3 my-3" text-xs-center></v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
        <!-- Category Stats -->
        <v-flex xs12 sm4 :class="mobilePie">
          <v-flex xs12 class="statsStyle statsBorder">
            <pie-chart :chart-data="pieChart" :options="optionsPie" :height="chartHeight"></pie-chart>
          </v-flex>
          <v-layout row wrap justify-center align-center text-xs-center>
            <!-- Small Stats -->
            <v-flex
              xs12
              class="font-number-2 white--text mt-3"
              style="font-size:30px"
            >{{mostViewedVideo}}</v-flex>
            <v-flex xs12 class="mb-3" v-lang.mostViewedVideo></v-flex>
            <v-flex xs12 class="font-number-2 white--text" style="font-size:30px">{{mostLikedVideo}}</v-flex>
            <v-flex xs12 class="mb-3" v-lang.mostLikedVideo></v-flex>
            <v-flex
              xs12
              class="font-number-2 white--text"
              style="font-size:30px"
            >{{mostViewedCategory}}</v-flex>
            <v-flex xs12 class="mb-3" v-lang.mostViewedCategory></v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </section>
    <!-- Footer -->
    <c-footer></c-footer>
  </v-content>
</template>

<script>
import LineChart from "./LineChart.js";
import pieChart from "./PieChart.js";
import CFooter from "./Footer";

export default {
  data() {
    return {
      optionsLine: {
        tooltips: { enabled: false },
        hover: { mode: null },
        layout: {
          padding: {
            left: 15,
            right: 15,
            top: 0
          }
        },
        legend: {
          labels: {
            fontColor: "white",
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "white",
                fixedStepSize: 1
              },
              gridLines: {
                display: true,
                color: "rgba(128,128,128,0.3)",
                drawBorder: false
              },
              display: true
            }
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "white"
              },
              gridLines: {
                display: false,
                drawBorder: false
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false
      },
      optionsPie: {
        cutoutPercentage: 50,
        legend: {
          labels: {
            fontColor: "white",
            usePointStyle: true
          },
          position: "left"
        },
        title: {
          display: false
        },
        plugins: {
          datalabels: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        pieceLabel: {
          render: "percentage",
          fontSize: 16,
          fontColor: "white",
          precision: 0
        }
      },
      startDateMenu: false,
      endDateMenu: false,
      selectedPlayer: null,
      startDate: "",
      endDate: "",
      startDateTemp: "",
      endDateTemp: "",
      tempSelVid: null,
      totalViewsPer: null,
      totalLikesPer: null,
      totalDislikesPer: null,
      selectedVideos: [],
      pieChartData: {}
    };
  },
  components: {
    LineChart,
    pieChart,
    CFooter
  },
  props: {
    lang: String
  },
  methods: {
    getDeviceById(id) {
      let n = this.$store.getters.getDevices.find(device => {
        return device.id == id;
      });
      if (n != undefined) {
        return n.name;
      } else {
        return "a";
      }
    },
    updateSelectedDevice() {
      this.$store.dispatch("changeSelectedStats", this.selectedPlayer.statsId);
    },
    changeStartDate() {
      this.startDate = this.startDateTemp;
      this.startDateMenu = false;
      this.$store.dispatch("changeStartDate", this.startDate);
    },
    changeEndDate() {
      this.endDate = this.endDateTemp;
      this.endDateMenu = false;
      this.$store.dispatch("changeEndDate", this.endDate);
    },
    getVideoById(id) {
      if (id != null) {
        return this.$store.getters.getVideos.find(video => {
          return video.id == id;
        });
      }
    },
    getCategoryById(id) {
      if (id != null) {
        return this.$store.getters.getCategories.find(cat => {
          return cat.id == id;
        });
      }
    },
    downloadStats() {
      if (this.selectedPlayer !== null) {
        this.$store.dispatch("downloadStats");
      } else {
      }
    },
    changeSelectedVideo() {
      this.$store.dispatch("changeSelectedVideo", this.selectedVideos);
    },
    localeLang() {
      if (this.language == "en") {
        return "en-UK";
      } else if (this.language == "fi") {
        return "fi-fi";
      } else {
        return "sv-se";
      }
    },
    selPlayerLang() {
      if (this.language == "en") {
        return "Select Player";
      } else if (this.language == "fi") {
        return "Valitse laite";
      } else {
        return "Välj enhet";
      }
    },
    selDateStartLang() {
      if (this.language == "en") {
        return "Select Start Date";
      } else if (this.language == "fi") {
        return "Valitse alkamispäivä";
      } else {
        return "Välj startdatum";
      }
    },
    selDateEndLang() {
      if (this.language == "en") {
        return "Select End Date";
      } else if (this.language == "fi") {
        return "Valitse päättymispäivä";
      } else {
        return "Välj slutdatum";
      }
    },
    selClassLang() {
      if (this.language == "en") {
        return "Select Class";
      } else if (this.language == "fi") {
        return "Valitse tunti";
      } else {
        return "Välj klass";
      }
    },
    updateBtnLang() {
      if (this.language == "en") {
        return "Update";
      } else if (this.language == "fi") {
        return "Päivitä";
      } else {
        return "Uppdatering";
      }
    },
    labelsLang(type) {
      let arr = [
        ["Dislikes", "Ei tykkää", "Ogillar"],
        ["Likes", "Tykkää", "Gillar"],
        ["Views", "Katselukerrat", "Visningar"]
      ];
      if (this.language == "en") {
        return arr[type][0];
      } else if (this.language == "fi") {
        return arr[type][1];
      } else {
        return arr[type][2];
      }
    },
    getViewStatById(id) {
      let b = [];
      this.$store.getters.getViewsFromSelectedVideos.forEach(day => {
        b.push(
          day.filter(el => {
            return el.videoId === id;
          }).length
        );
      });
      return b;
    },
    getLikesStatById(id) {
      let b = [];
      this.$store.getters.getLikesFromSelectedVideos.forEach(day => {
        b.push(
          day.filter(el => {
            return el.videoId === id;
          }).length
        );
      });
      return b;
    },
    getDislikesStatById(id) {
      let b = [];
      this.$store.getters.getDislikesFromSelectedVideos.forEach(day => {
        b.push(
          day.filter(el => {
            return el.videoId === id;
          }).length
        );
      });
      return b;
    }
  },
  mounted() {
    if (this.$store.getters.getSelectedStats !== null) {
      this.selectedPlayer = this.$store.getters.getDevices.find(dev => {
        return dev.statsId == this.$store.getters.getSelectedStats;
      });
    }
    this.startDate = this.$store.getters.getStartDate;
    this.endDate = this.$store.getters.getEndDate;
    this.startDateTemp = this.startDate;
    this.endDateTemp = this.endDate;
  },
  computed: {
    mostViewedVideo() {
      if (
        this.getVideoById(this.$store.getters.getMostViewedVideo) === undefined
      ) {
        return "-";
      } else {
        return this.getVideoById(this.$store.getters.getMostViewedVideo).name;
      }
    },
    mostLikedVideo() {
      if (
        this.getVideoById(this.$store.getters.getMostLikedVideo) === undefined
      ) {
        return "-";
      } else {
        return this.getVideoById(this.$store.getters.getMostLikedVideo).name;
      }
    },
    mostViewedCategory() {
      if (
        this.$store.getters.getViewsByCategory === null ||
        this.$store.getters.getViewsByCategory.length === 0
      ) {
        return "-";
      } else {
        let dogtron = this.$store.getters.getViewsByCategory.sort(function(
          a,
          b
        ) {
          if (a.views > b.views) {
            return -1;
          }
          if (a.views < b.views) {
            return 1;
          }
          return 0;
        });
        if (dogtron !== undefined) {
          return this.getCategoryById(dogtron[0].id).name;
        }
      }
    },
    getAvailableClasses() {
      let self = this;
      if (this.selectedPlayer !== null) {
        var filtered = this.$store.getters.getCategories.filter(cat => {
          return this.selectedPlayer.categories.find(c => {
            return cat.id == c;
          });
        });
        let videos = [];
        filtered.forEach(cat => {
          cat.videos.forEach(dd => {
            if (
              videos.findIndex(y => {
                return y == dd;
              }) == -1
            ) {
              videos.push(dd);
            }
          });
        });

        let t = [];
        this.$store.getters.getVideos
          .filter(el => {
            return videos.find(v => {
              return v == el.id;
            });
          })
          .forEach(element => {
            t.push({
              id: element.id,
              name: element.name
            });
          });
        t.sort(function(a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });

        t.forEach(e => {
          this.selectedVideos.push(e.id);
        });
        console.log(this.selectedVideos);
        return t;
      } else {
        return [];
      }
    },
    viewChart() {
      if (this.$store.getStats !== null) {
        let vNum = [];
        let lNum = [];
        let dNum = [];
        let parsedDates = [];
        let viewsColor = "#0396FF";
        let likesColor = "#49C628";
        let dislikesColor = "#E80505";
        let gradViews = null;
        let gradLikes = null;
        let gradDislikes = null;
        let canvas = document.createElement("canvas");

        this.$store.getters.getStats.forEach(stat => {
          vNum.push(stat.views.length);
          lNum.push(stat.likes.length);
          dNum.push(stat.dislikes.length);
        });

        this.totalViewsPer = vNum.reduce(function(a, b) {
          return a + b;
        }, 0);
        this.totalLikesPer = lNum.reduce(function(a, b) {
          return a + b;
        }, 0);
        this.totalDislikesPer = dNum.reduce(function(a, b) {
          return a + b;
        }, 0);

        gradViews = canvas.getContext("2d").createLinearGradient(0, 0, 0, 800);
        gradViews.addColorStop(0, viewsColor);
        gradViews.addColorStop(0.8, "rgba(48, 48, 48, 0)");

        gradLikes = canvas.getContext("2d").createLinearGradient(0, 0, 0, 800);
        gradLikes.addColorStop(0, likesColor);
        gradLikes.addColorStop(0.8, "rgba(48, 48, 48, 0)");

        gradDislikes = canvas
          .getContext("2d")
          .createLinearGradient(0, 0, 0, 800);
        gradDislikes.addColorStop(0, dislikesColor);
        gradDislikes.addColorStop(0.8, "rgba(48, 48, 48, 0)");

        this.$store.getters.getDateRangeArray.forEach(e => {
          parsedDates.push(e.slice(5));
        });

        let chartData = {
          labels: parsedDates,
          datasets: [
            {
              label: this.labelsLang(0),
              borderColor: dislikesColor,
              borderWidth: 8,
              backgroundColor: gradDislikes,
              lineTension: 0.1,
              data: dNum
            },
            {
              label: this.labelsLang(1),
              borderColor: likesColor,
              borderWidth: 8,
              backgroundColor: gradLikes,
              lineTension: 0.1,
              data: lNum
            },
            {
              label: this.labelsLang(2),
              borderColor: viewsColor,
              borderWidth: 8,
              backgroundColor: gradViews,
              lineTension: 0.1,
              data: vNum
            }
          ]
        };
        return chartData;
      } else {
        return {
          labels: [],
          datasets: []
        };
      }
    },
    pieChart() {
      if (this.$store.getters.getViewsByCategory !== null) {
        return {
          labels: this.$store.getters.getViewsByCategory.map(
            a => this.getCategoryById(a.id).name
          ),
          datasets: [
            {
              borderColor: this.$store.getters.getViewsByCategory.map(
                a => this.getCategoryById(a.id).accent
              ),
              borderWidth: 1,
              backgroundColor: this.$store.getters.getViewsByCategory.map(a =>
                this.getCategoryById(a.id).accent.replace(",1)", ",0.3)")
              ),
              data: this.$store.getters.getViewsByCategory.map(a => a.views)
            }
          ]
        };
      } else {
        return {
          labels: [],
          datasets: []
        };
      }
    },
    chartHeight() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 450;
      } else {
        return 250;
      }
    },
    mobilePie() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "pt-3 pl-3";
      } else {
        return "pt-3";
      }
    },
    mobileSel() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "";
      } else {
        return "mb-3";
      }
    }
  }
};
</script>

<style>
statsStyle {
  max-width: 100%;
  max-height: 450px;
  background: linear-gradient(#303030, #252525 10%, #252525 90%, #303030);
}

.statsBorder {
  border-right: 2px solid;
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
#dateSelBar .input-group__details {
  display: none;
}
#classSelBar .input-group__input:before {
  display: none;
}

.likesCol {
  background: linear-gradient(-45deg, rgb(2, 218, 92), rgb(49, 203, 230));
}

.dislikesCol {
  background: linear-gradient(-45deg, rgb(253, 46, 125), rgb(236, 32, 42));
}

.viewsCol {
  background: linear-gradient(-45deg, rgb(248, 135, 82), rgb(76, 142, 241));
}

.containerCircle {
  position: relative;
  width: 150px;
  height: 150px;
  margin: auto auto;
}

.outerCircle {
  border-radius: 50%;
  animation: rotation 2s infinite linear;
  width: 150px;
  height: 150px;
  margin: auto auto;
  top: 0px;
  left: 0px;
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5);
  position: absolute;
}

.innerCircle {
  position: absolute;
  top: 10px;
  left: 10px;
  text-align: center;
  background: #303030;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  line-height: 2;
  box-shadow: inset 0px 0px 20px 2px rgba(0, 0, 0, 0.5);
}

@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics.vue